var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.debug)?_c('v-card',[(_vm.title)?_c('v-card-title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('vue-json-pretty',{attrs:{"data":_vm.data,"showDoubleQuotes":false,"showLineNumber":true,"showIcon":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }